<div class="popupu_card ci_popup_card pop_active_card" *ngIf="showaddplancalendar">
  <div class="popup_inner" style="width: 100%; height: 0; box-shadow: none; border: 0; background-color: transparent;">

    <mat-form-field>
      <input id="txtdt" matInput style="height:10px;width:100%;left: -50%; transform: translateX(50%);" type="text" [min]="this.currdate"
        [ngxMatDatetimePicker]="picker" placeholder="Choose a date" (click)="Callopen_cal(picker)"
        [(ngModel)]="this.state.meetingdate.value">
      <!-- <mat-datepicker-toggle matSuffix [for]="$any(picker)">
                </mat-datepicker-toggle> -->

      <ngx-mat-datetime-picker  panelClass="divclsAddPlan" (closed)="AddPlanclosed()" (opened)="onOpen()" #picker [showSpinners]="true">
        <ngx-mat-datepicker-actions>
          <div class="clnd_two_btn_card">

            <button mat-button ngxMatDatepickerCancel (click)="AddPlanCancelled()">Cancel</button>
            <button mat-raised-button color="primary" ngxMatDatepickerApply  (click)="AddPlanApply()">Add to Plan</button>

          </div>
        </ngx-mat-datepicker-actions>
      </ngx-mat-datetime-picker>
    </mat-form-field>

  </div>

</div>